import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.989}
    height={15.905}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 25301 15484"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#2b2a29;stroke-width:280.382}.fil0{fill:#2b2a29;fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974616793328">
        <path
          d="M24122 4023v79c0 1153-458 2204-1197 2967-741 765-1764 1241-2890 1241H5266c-1127 0-2149-476-2890-1241l-2-2c-737-762-1195-1813-1195-2965v-544l466 15 51 1v-1h192l62 6c16 2 33 4 51 5h5l51 1h21187c42 0 78-2 107-6l62-6h193v1l50-1 466-15v465zm-1843 2417c496-512 831-1193 917-1951H2105c87 758 422 1439 919 1953 576 594 1370 964 2242 964h14769c873 0 1668-370 2244-966z"
          className="fil0"
        />
        <path
          d="M592 140h24569v1878c0 428-175 817-456 1099-282 281-671 456-1099 456H1696c-429 0-818-175-1100-456-281-282-456-671-456-1099V140h452zm23665 905H1045v973c0 178 74 341 191 459 118 118 281 192 460 192h21910c178 0 341-74 459-192s192-281 192-459v-973zM13037 15344c-217 0-413-89-555-230-141-141-229-338-229-555v-2790c0-217 88-413 230-555l1 1c142-143 338-231 553-231 217 0 413 88 555 230v2c141 142 229 337 229 553v2790c0 217-88 414-229 555-142 141-338 230-555 230zM1448 12240l-132-133v-44c-65-117-97-248-97-378 0-200 76-402 229-555l1974-1973v-1h2c153-152 353-229 552-229 130 0 260 33 377 97h46l132 133v2c153 153 230 353 230 552 0 201-77 402-230 555l-1973 1974h-2c-153 152-354 229-553 229-200 0-402-77-555-229z"
          className="fil0"
        />
        <path
          d="M7589 14570c-181 84-395 100-597 28l-5-2c-200-74-354-224-439-404-84-182-100-396-27-598l1-1 954-2623 1-1c73-202 222-355 402-440l4-2c179-83 391-98 593-26l4 1c202 73 356 224 441 405l2 2c83 179 99 393 25 596l-954 2623c-74 202-224 357-405 442zm-112-3601z"
          className="fil0"
        />
        <path
          id={1}
          d="M7589 14570c-181 84-395 100-597 28l-5-2c-200-74-354-224-439-404-84-182-100-396-27-598l1-1 954-2623 1-1c73-202 222-355 402-440l4-2c179-83 391-98 593-26l4 1c202 73 356 224 441 405l2 2c83 179 99 393 25 596l-954 2623c-74 202-224 357-405 442zm-112-3601"
          className=""
          style={{
            fill: "none",
            fillRule: "nonzero",
          }}
        />
        <path
          d="M23985 12063v44l-132 133c-153 152-355 229-555 229-199 0-399-77-553-229h-2l-1973-1974c-153-153-230-354-230-555 0-199 77-399 230-552v-2l132-133h46c117-64 247-97 377-97 199 0 399 77 552 229h2v1l1974 1973c153 153 229 355 229 555 0 130-32 261-97 378zM18441 14596h-1v1c-203 74-417 58-599-27-181-85-331-240-405-442l-955-2623c-73-202-58-416 26-596 85-182 239-333 441-407l5-1c202-72 414-57 594 26 182 85 332 240 407 443l954 2623v1c73 202 58 416-27 598-84 180-239 330-440 404z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
